import * as Yup from 'yup'

export const validationSchema = (formatMessage) =>
  Yup.object().shape({
    gender: Yup.string().required(formatMessage('form.error.required')),
    bornAs: Yup.string().required(formatMessage('form.error.required')),
    sexuality: Yup.string().required(formatMessage('form.error.required')),
    relationship: Yup.string(),
    race: Yup.array()
      .min(1, formatMessage('profile.demographics.race.min'))
      .of(Yup.string())
      .required(formatMessage('form.error.required')),
    ethnicity: Yup.string().required(formatMessage('form.error.required')),
  })

export const getInitialValues = (user) => {
  return {
    gender: user?.gender ?? '',
    bornAs: user?.bornAs ?? '',
    sexuality: user?.sexuality ?? '',
    relationship: user?.relationship ?? '',
    race: (user?.race ?? []).filter((v) => Boolean(v)),
    ethnicity: user?.ethnicity ?? '',
  }
}

export const formikToApiData = (data) => {
  return {
    patient: {
      gender: data.gender,
      sex: data.bornAs,
      sexuality: data.sexuality,
      relationship: data.relationship,
      race: data.race,
      ethnicity: data.ethnicity,
    },
  }
}

export const getMissingInfo = (user, formatMessage) => {
  const values = getInitialValues(user)
  const errors = {}
  if (!values.gender) {
    errors.gender = formatMessage('profile.demographics.gender.select')
  }
  if (!values.bornAs) {
    errors.bornAs = formatMessage('profile.demographics.bornAs.select')
  }
  if (!values.sexuality) {
    errors.sexuality = formatMessage('profile.demographics.sexuality.select')
  }
  if (values.race.length === 0) {
    errors.race = formatMessage('profile.demographics.race.select')
  }
  if (!values.ethnicity) {
    errors.ethnicity = formatMessage('profile.demographics.ethnicity.select')
  }
  return errors
}
